import { borderRadius, breakpoint, colors, fontSize, fontWeight, mediaQueryHelper } from '@offerzen/pinata'
import { css } from '@emotion/css'

const styles = {
  footerDetails: css({
    lineHeight: '140%',
    maxWidth: '100%',
    textAlign: 'left',
    color: '#131F4A',
    margin: 'auto',
    marginBottom: 0,
    [mediaQueryHelper(breakpoint.phone)]: {
      textAlign: 'center',
    },

    strong: {
      fontWeight: fontWeight.bold,
      fontSize: fontSize.large,
      lineHeight: '140%',
    },

    p: {
      color: colors.blackPearl,
      fontWeight: fontWeight.regular,
      fontSize: fontSize.default,
      marginTop: 12,
      marginBottom: 22,
    },
  }),

  button: css({
    position: 'relative',
    display: 'inline-block',
    width: 'calc(100% - 28px)',
    margin: 'auto',
    textDecoration: 'none',
    backgroundColor: colors.amethyst,
    boxShadow: '0px 3px 8px rgba(19, 34, 84, 0.15)',
    borderRadius: borderRadius.medium,
    color: colors.white,
    fontWeight: fontWeight.semiBold,
    transition:
      'transform .3s cubic-bezier(.55, .085, .68, .53),background-color .3s cubic-bezier(.55, .085, .68, .53),box-shadow .2s,-webkit-transform .3s cubic-bezier(.55, .085, .68, .53)',
    textAlign: 'center',
    padding: 14,
    lineHeight: '17px',

    '&:hover, &:focus': {
      backgroundColor: colors.havelockBlue,
      boxShadow: '0 2px 4px rgb(0 0 0 / 10%)',
    },

    [mediaQueryHelper(breakpoint.phone)]: {
      width: 'auto',
    },
  }),

  scrollToTop: css({
    paddingTop: '12px',
    fontWeight: fontWeight.medium,

    a: {
      color: colors.cornflowerBlue,
      textDecoration: 'underline',
    },
  }),

  emailFormContainer: css({
    maxWidth: 'initial',
    margin: 0,

    [mediaQueryHelper(breakpoint.phone)]: {
      maxWidth: 450,
      margin: 'auto',
    },
  }),

  footerCtaContainer: css({
    display: 'flex',
    flexDirection: 'column',
    margin: 0,

    [mediaQueryHelper(breakpoint.phone)]: {
      margin: 'auto',
      justifyContent: 'center',
      flexDirection: 'row',
    },
  }),

  footerCtaButton: css({
    display: 'flex',
    alignItems: 'center',
    minWidth: 160,
    borderRadius: 4,
    fontWeight: 700,
    fontSize: 16,
    lineHeight: '16px',
    padding: '0 15px',
    textDecoration: 'none',
    justifyContent: 'center',
    transition: 'all .3s ease-in-out',
  }),

  signupButton: css({
    backgroundColor: '#5EA5EE',
    marginRight: 0,
    marginBottom: 12,
    height: 45,
    color: '#FFFFFF',

    '&:hover, &:focus': {
      backgroundColor: '#2E71C1',
      boxShadow: '0px 4px 4px rgba(19, 34, 84, 0.15)',
    },

    [mediaQueryHelper(breakpoint.phone)]: {
      marginRight: 12,
      marginBottom: 0,
    },
  }),

  bookDemoButton: css({
    backgroundColor: '#EEF3F6',
    border: '1px solid #5EA5EE',
    maxHeight: 43,
    height: 43,
    color: '#5EA5EE',

    '&:hover, &:focus': {
      backgroundColor: '#5EA5EE',
      color: '#FFF',
    },
  }),
}

export default styles
